<template>
  <v-img
    class="hs"
    :src="iconSource"
    contain
    @click="clicked"
    :style="styling"
  />
</template>
<script>

const DEFAULT_HOTSPOT_SIZE_WITH_TEXT = 28;
const DEFAULT_HOTSPOT_SIZE = 37;
const DEFAULT_HOTSPOT_TEXT_SIZE = 8;
const BROWSER_SIZE_OFFSET = 505;
const HEIGHT_OFFSET_WITHOUT_TEXT = -1;

import EventBus from '@/EventBus';

export default {
  name: 'hotspot',
  props: {
    isVideo: {
      type: Boolean,
      required: false,
    },
    hs: {
      type: Object,
      required: true,
    },
    ptop: {
      type: Number,
      required: false,
    },
    pleft: {
      type: Number,
      required: false,
    },
    pwidth: {
      type: Number,
      required: false,
    },
    pheight: {
      type: Number,
      required: false,
    },

  },
  created() {
    EventBus.$on('resized', this.listener);
  },
  beforeDestroy() {
    EventBus.$off('resized', this.listener);
  },

  data() {
    return {
      top: this.ptop,
      left: this.pleft,
      width: this.pwidth,
      height: this.pheight,
    };
  },
  computed: {
    styling() {
      // Calculate browser size offset
      const sizeOffset = this.height / BROWSER_SIZE_OFFSET;
      // Calculate icon size. Smaller on small screen and larger on large screen. DOH!
      const width = this.hs.customText
        ? sizeOffset * (DEFAULT_HOTSPOT_SIZE_WITH_TEXT * this.hs.scale)
        : sizeOffset * (DEFAULT_HOTSPOT_SIZE * this.hs.scale);
      const height = this.hs.customText
        ? sizeOffset * (DEFAULT_HOTSPOT_SIZE_WITH_TEXT * this.hs.scale)
        : sizeOffset * (DEFAULT_HOTSPOT_SIZE * this.hs.scale);

      // Add height offset if hotspot has title
      const heightOffset = this.hs.customText
        ? DEFAULT_HOTSPOT_TEXT_SIZE * this.hs.scale * sizeOffset
        : sizeOffset;

      const yaw = Number(this.hs.rotation.yaw);
      const pitch = Number(this.hs.rotation.pitch);

      // Calculate icon position
      const x = this.left + (yaw * this.width);
      const y = this.top + (pitch * this.height);

      return {
        marginTop: `-${(height + heightOffset) / 2}px`,
        marginLeft: `-${width / 2}px`,
        width: `${width}px`,
        height: `${height}px`,
        left: `${x}px`,
        top: `${y}px`,
      };
    },
    iconSource() {
      const iconSet = this.hs.customSetName || 'hotspot_00_Default';
      const extension = this.hs.customSetName ? '' : '.png';
      return `/${iconSet}/${this.hs.fileName}${extension}`;
    },
  },
  methods: {
    listener(event) {
      const { top, left, width, height } = event;
      this.top = top;
      this.left = left;
      this.width = width;
      this.height = height;
    },
    clicked() {
      if (this.hs.hotspotType === 3) {
        if (this.hs.actionURL.includes('http://') || this.hs.actionURL.includes('https://')) {
          window.open(this.hs.actionURL, 'eSiteExternal');
        } else {
          window.open(`https://${this.hs.actionURL}`, 'eSiteExternal');
        }
      } else {
        this.$store.commit('customText', this.hs.customText);
        this.$store.commit('hotspotDescription', this.hs.hotspotDescription);
        this.$store.commit('currentHotspot', this.hs);
      }
      this.$player.pause();
    },
  },
};
</script>

<style scoped>
.hs {
  cursor: pointer;
  position: fixed;
}
</style>
